import {HttpHeaders} from '@angular/common/http';
import {GtProducts} from '@app/models/enums/gt-products.enum';
import {
  AuthenticationServiceInterface,
  Configuration,
  GetSubscriptionsResponse,
  LoginDto,
  LoginResponse,
  LoginTokenDto,
  LogoutResponse,
  Response as MSGResponse,
  Subscription,
  TokenResponse,
  UserData
} from '@gt-api';
import {MockData} from '@testhelper/mock-data';
import {Observable, of} from 'rxjs';

export class AuthenticationServiceStub implements AuthenticationServiceInterface {
  defaultHeaders = new HttpHeaders();
  configuration = new Configuration();

  getSubscriptions1(extraParams?: any): Observable<GetSubscriptionsResponse> {
    const subscriptions: Subscription[] = [
      {product: {id: 1020, description: 'attendant'}, attributes: {}},
      {
        product: {id: 2000, description: 'vpn service provider'},
        attributes: {OrganizationRights: [31], EndUserRights: [31], ServiceRights: [31], ServiceProviderRights: [31]}
      },
      {product: {id: 2010, description: 'vpn administrator'}, attributes: {}},
      {product: {id: 2020, description: 'vpn enduser'}, attributes: {}},
      {product: {id: 3000, description: 'Switchboard Access'}, attributes: {}},
      {product: {id: GtProducts.TRIGGERING_PRODUCT, description: 'Triggering'}, attributes: {}}
    ];
    return of({
      code: 200,
      subscriptions
    });
  }

  getToken1(extraParams?: any): Observable<TokenResponse> {
    return of({code: 200, token: '$$!"QRW#"RFU)UFQE)'});
  }

  getTokenWithRole1(role: string, extraParams?: any): Observable<TokenResponse> {
    return undefined;
  }

  login1(organization?: string, login?: string, password?: string, appId?: string, extraParams?: any): Observable<LoginResponse> {
    const e = MockData.endUsers.find(eu => eu.login === login) ?? MockData.endUsers[0];
    let userData: UserData;
    if (e) {
      userData = {
        fullNumber: e.fullNumber,
        login: e.login,
        organization: e.organization,
        status: 0,
        administrator: true,
        attendant: true,
        lastName: e.lastName,
        customerCare: false,
        email: e.email,
        firstName: e.firstName,
        language: 'nb-NO',
        recordEnabled: false,
        serviceProvider: false,
        vpnAdministrator: true,
        vpnEndUser: true
      };
    }
    const code = e ? 200 : 401;
    return of({
      code,
      userData
    });
  }

  loginWithDto1(body?: LoginDto, extraParams?: any): Observable<LoginResponse> {
    return this.login1(body.organization, body.login, body.password, body.appId, extraParams);
  }

  loginWithTokenDto1(body?: LoginTokenDto, extraParams?: any): Observable<LoginResponse> {
    return undefined;
  }

  logout1(extraParams?: any): Observable<LogoutResponse> {
    return of({
      code: 200
    });
  }

  resetPassword1(body?: LoginDto, extraParams?: any): Observable<MSGResponse> {
    return of({
      code: 200
    });
  }

  sendPasswordOnSMS1(body?: LoginDto, extraParams?: any): Observable<MSGResponse> {
    return of({
      code: 200
    });
  }
}
